import { render, staticRenderFns } from "./MimdgcategoriaestibaForm.vue?vue&type=template&id=70dd22d5"
import script from "./MimdgcategoriaestibaForm.vue?vue&type=script&lang=js"
export * from "./MimdgcategoriaestibaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports